import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicTextArea } from 'core/components';

function NikoFacilityOrderPatientTemplateNoteModalTemplate({ nikoFacilityOrderPatientTemplateNoteModalStore }) {
    const {
        form
    } = nikoFacilityOrderPatientTemplateNoteModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>{"Initial Intake Note"}</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('note')} isFocus={true} disabled={true}/>
                </div>
            </div>
        </section>
    )
}

NikoFacilityOrderPatientTemplateNoteModalTemplate.propTypes = {
    nikoFacilityOrderPatientTemplateNoteModalStore: PropTypes.object
};

export default defaultTemplate(NikoFacilityOrderPatientTemplateNoteModalTemplate);
